<template>
  <div class="container-fluid">
    <div class="form-row">
      <label class="col-form-label col-form-label-sm"><strong>Intstructor:</strong></label>
      <div class="form-group col-4">
        <v-select
          v-model="selected_user_id"
          :items="users"
          :plain="true"
          density="compact"
          item-title="text"
          item-value="value"
          variant="outlined"
          @update:model-value="loadSupplies"
        />
      </div>
      <label class="col-form-label col-form-label-sm"><span
        v-show="loading"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      /></label>
    </div>

    <div class="form-row">
      <div v-if="supplies.length" class="col-3">
        <supply-list
          :supply="supply"
          :supplies="supplies"
          :transactions-summary="transactionsSummary"
          @select-supply="selectSupply"
        />
      </div>

      <div v-if="supply" class="col-9">
        <h5>{{ supply.name }}</h5>
        <table class="table table-striped table-hover table-sm">
          <thead>
            <tr class="d-flex">
              <th class="col-2">
                <strong>#</strong>
              </th>
              <th class="col-2">
                <strong>Date</strong>
              </th>
              <th class="col-2">
                <strong>Type</strong>
              </th>
              <th class="col-2">
                <strong>Quantity</strong>
              </th>
              <th class="col-2">
                <strong>Tracking#</strong>
              </th>
              <th class="col-2">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(supply_transaction) in supply_transactions"
              :key="supply_transaction.id"
              class="d-flex"
            >
              <td class="col-2">
                <a
                  class="decorated"
                  :href="
                    '/supply/supplyOrderView.php?supplyOrderID=' +
                      supply_transaction.id
                  "
                >{{ supply_transaction.id }}</a>
              </td>
              <td class="col-2">
                {{
                  formatDate(supply_transaction.create_date)
                }}
              </td>
              <td class="col-2">
                <div v-if="supply_transaction.class_id">
                  <a
                    href="#"
                    class="decorated"
                  >Class# {{ supply_transaction.class_id }}</a>
                  expense
                </div>
                <div v-if="!supply_transaction.class_id">
                  Instructor Order
                </div>
              </td>
              <td class="col-2">
                <font
                  :color="supply_transaction.quantity > 0 ? 'green' : 'red'"
                >
                  {{ supply_transaction.quantity }}
                </font>
              </td>
              <td class="col-2">
                {{ supply_transaction.tracking_id }}
              </td>
              <td class="col-2">
                <strong>{{
                  supply_transaction_statuses[supply_transaction.status_id]
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
import axios from 'axios';

import SupplyList from './supplyList.vue';

export default {
  components: { SupplyList },
  props: ['value'],
  setup() {
    const formatDate = date => moment(date).format('MM/DD/YYYY');
    return {
      formatDate,
    };
  },
  data() {
    return {
      users: [],
      supply: null,
      supplies: [],
      transactionsSummary: [],
      supply_transactions: [],
      selected_user_id: null,
      loading: true,
      supply_transaction_statuses: {
        8210: 'New',
        8220: 'Fulfilled',
      },
    };
  },

  async mounted() {
    const response = await axios.get('/api/users/instructors');
    this.users = response.data.data.map(obj => ({
      value: obj.id,
      text: `${obj.first_name} ${obj.last_name}`,
    }));
    this.selected_user_id = this.users[0].value;
    this.loadSupplies();
  },

  methods: {
    async loadSupplies() {
      this.loading = true;
      this.supply = null;
      this.supply_transactions = [];
      const response = await axios.get(
        `/api/users/${this.selected_user_id}/supplies`,
      );
      this.supplies = response.data.map(obj => obj.supply);

      this.transactionsSummary = [];
      response.data.map(obj => {
        this.transactionsSummary[obj.supply.id] = {
          quantity_balance: obj.quantity_balance,
          total_transactions: obj.total_transactions,
        };
      });

      if (this.supplies.length) {
        this.selectSupply(this.supplies[0]);
      }

      this.loading = false;
    },

    async selectSupply(supply) {
      this.supply = supply;
      this.loadTransactions();
    },

    async loadTransactions() {
      this.loading = true;
      const response = await axios.get(
        `/api/users/${this.selected_user_id}/supplies/${this.supply.id}/transactions`,
      );
      this.supply_transactions = response.data;
      this.loading = false;
    },
  },
};
</script>
